import { Role } from 'types/types';
import { ROLES } from 'variables';

export const isSuperAdmin = (role?: Role): boolean => role === 'SUPER_ADMIN';

export const isSuperAdminOrg = (role?: Role[] | undefined): boolean =>
  !!role?.includes('SUPER_ADMIN');

export const isGroupManager = (role?: Role): boolean =>
  role === 'GROUP_MANAGER';

export const isAdvancedUser = (role?: Role): boolean =>
  role === 'ADVANCED_USER';

export const isStandardUser = (role?: Role): boolean => role === 'STANDARD';

export const isRestrictedUser = (role?: Role): boolean =>
  role === 'RESTRICTED_USER';

export const getRoleDescription = (role: Role) => {
  return ROLES[role ?? 'STANDARD'];
};

export const isRolePermitted = (userRole: Role, permittedRoles: Role[]) => {
  return permittedRoles.includes(userRole);
};
